import { Button, Input, message } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
import API from '../../../../../utils/api'
import { useToken } from '../../../../hooks'
import { CButton } from '../../../../components/Common'
import { COLORS } from '../../../../constants'
import { useNotification } from '../../../../hooks/useNotification'

const ActionButton = ({ title, process, id, mutate = () => {} }: any) => {
	const { data: token } = useToken()
	const { refresh: notimutate } = useNotification()

	const saveProcess = () => {
		API.send(
			'PUT',
			'/admin/user/withdrawwallet',
			token + '',
			{
				id,
				process,
				type: 'W',
			},
			false
		)
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate()
					notimutate()
				} else {
					message.error(res?.result?.message || '실패')
				}
			})
			.catch(err => {
				message.error('실패:' + err.message)
			})
	}

	return (
		<CButton
			title={title}
			onClick={saveProcess}
			style={{
				background: process == 2 ? COLORS.darkRed : COLORS.secondary,
				color: COLORS.white,
				fontSize: 11,
				padding: '5px 5px',
				marginRight: 5,
			}}
		/>
	)
}

export default React.memo(ActionButton)
